import { defineStyleConfig } from '@chakra-ui/react'
import type { StyleFunctionProps } from '@chakra-ui/styled-system'

const Checkbox = defineStyleConfig({
  sizes: {
    md: {
      control: {
        w: 30,
        h: 30
      }
    }
  },
  variants: {
    circular: (props: StyleFunctionProps) => ({
      control: {
        bg: props.colorMode === "light" ? "white" : "alphaWhite01",
        borderColor: props.colorMode === "light" ? "border" : "transparent",
        rounded: "full",
        _checked: {
          bg: "primary",
          borderColor: "primary",
          _hover: {
            bg: "primary",
            borderColor: "primary"
          }
        }
      }
    })
  },
  defaultProps: {
    size: "md",
    variant: "circular"
  }
})
export default Checkbox